// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template {
  margin: 10px 10px 10px 10px;
  padding: 0 20px 20px 20px;
  border-radius: 15px;
  display: block;
  position: relative;
  align-items: stretch;
  min-height: 100px;
}
.template .border {
  border-bottom: 1px solid #e3e2df;
}
.template .border p {
  margin-bottom: 10px;
  text-align: justify;
}
.template .border li {
  list-style-type: none;
}

h1 {
  margin: 40px 40px 0 50px;
}

a {
  color: #000;
}
a span {
  color: #606060;
}

h2 {
  margin-bottom: 20px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  margin-left: 20px;
}
.row .col-sm {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.row .col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.align {
  float: right;
}

.active {
  color: #FF4612;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRlcm1zLWFuZC1jb25kaXRpb25zLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsMkJBQUE7RUFDQSx5QkFBQTtFQUVBLG1CQUFBO0VBQ0EsY0FBQTtFQUNBLGtCQUFBO0VBQ0Esb0JBQUE7RUFDQSxpQkFBQTtBQUFGO0FBRUU7RUFDRSxnQ0FBQTtBQUFKO0FBRUk7RUFDRSxtQkFBQTtFQUNBLG1CQUFBO0FBQU47QUFHSTtFQUNFLHFCQUFBO0FBRE47O0FBTUE7RUFDRSx3QkFBQTtBQUhGOztBQU1BO0VBQ0UsV0FBQTtBQUhGO0FBSUU7RUFDRSxjQUFBO0FBRko7O0FBTUE7RUFDRSxtQkFBQTtBQUhGOztBQU1BO0VBQ0UsYUFBQTtFQUNBLGVBQUE7RUFDQSxrQkFBQTtFQUNBLGlCQUFBO0FBSEY7QUFLQTtFQUNFLGFBQUE7RUFHRSxZQUFBO0VBQ0EsZUFBQTtBQUhKO0FBTUE7RUFHRSxhQUFBO0VBQ0EsY0FBQTtBQUpGOztBQVFBO0VBQ0UsWUFBQTtBQUxGOztBQVFBO0VBQ0UsY0FBQTtBQUxGIiwiZmlsZSI6InRlcm1zLWFuZC1jb25kaXRpb25zLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRlbXBsYXRlIHtcbiAgbWFyZ2luOiAxMHB4IDEwcHggMTBweCAxMHB4O1xuICBwYWRkaW5nOiAwIDIwcHggMjBweCAyMHB4O1xuICAvLyBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICBib3JkZXItcmFkaXVzOiAxNXB4O1xuICBkaXNwbGF5OiBibG9jaztcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBhbGlnbi1pdGVtczogc3RyZXRjaDtcbiAgbWluLWhlaWdodDogMTAwcHg7XG5cbiAgLmJvcmRlcntcbiAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgI2UzZTJkZjtcblxuICAgIHB7XG4gICAgICBtYXJnaW4tYm90dG9tOiAxMHB4O1xuICAgICAgdGV4dC1hbGlnbjoganVzdGlmeTtcbiAgICB9XG5cbiAgICBsaSB7XG4gICAgICBsaXN0LXN0eWxlLXR5cGU6IG5vbmU7XG4gIH1cbiAgfVxufVxuXG5oMXtcbiAgbWFyZ2luOiA0MHB4IDQwcHggMCA1MHB4O1xufVxuXG5he1xuICBjb2xvcjogIzAwMDtcbiAgc3BhbiB7XG4gICAgY29sb3I6ICM2MDYwNjA7XG4gIH1cbn1cblxuaDJ7XG4gIG1hcmdpbi1ib3R0b206IDIwcHg7XG59XG5cbi5yb3d7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgbWFyZ2luLXJpZ2h0OiAyMHB4O1xuICBtYXJnaW4tbGVmdDogMjBweDtcblxuLmNvbC1zbXtcbiAgZmxleC1iYXNpczogMDtcbiAgICAtd2Via2l0LWJveC1mbGV4OiAxO1xuICAgIC1tcy1mbGV4LXBvc2l0aXZlOiAxO1xuICAgIGZsZXgtZ3JvdzogMTtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG59XG5cbi5jb2wtNntcbiAgLXdlYmtpdC1ib3gtZmxleDogMDtcbiAgLW1zLWZsZXg6IDAgMCA1MCU7XG4gIGZsZXg6IDAgMCA1MCU7XG4gIG1heC13aWR0aDogNTAlO1xufVxufVxuXG4uYWxpZ257XG4gIGZsb2F0OiByaWdodDtcbn1cblxuLmFjdGl2ZXtcbiAgY29sb3I6ICNGRjQ2MTI7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/containers/static-resources/terms-and-conditions/terms-and-conditions.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,yBAAA;EAEA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAAF;AAEE;EACE,gCAAA;AAAJ;AAEI;EACE,mBAAA;EACA,mBAAA;AAAN;AAGI;EACE,qBAAA;AADN;;AAMA;EACE,wBAAA;AAHF;;AAMA;EACE,WAAA;AAHF;AAIE;EACE,cAAA;AAFJ;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAHF;AAKA;EACE,aAAA;EAGE,YAAA;EACA,eAAA;AAHJ;AAMA;EAGE,aAAA;EACA,cAAA;AAJF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,cAAA;AALF;AAHA,4+DAA4+D","sourcesContent":[".template {\n  margin: 10px 10px 10px 10px;\n  padding: 0 20px 20px 20px;\n  // background-color: #fff;\n  border-radius: 15px;\n  display: block;\n  position: relative;\n  align-items: stretch;\n  min-height: 100px;\n\n  .border{\n    border-bottom: 1px solid #e3e2df;\n\n    p{\n      margin-bottom: 10px;\n      text-align: justify;\n    }\n\n    li {\n      list-style-type: none;\n  }\n  }\n}\n\nh1{\n  margin: 40px 40px 0 50px;\n}\n\na{\n  color: #000;\n  span {\n    color: #606060;\n  }\n}\n\nh2{\n  margin-bottom: 20px;\n}\n\n.row{\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: 20px;\n  margin-left: 20px;\n\n.col-sm{\n  flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n}\n\n.col-6{\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n}\n\n.align{\n  float: right;\n}\n\n.active{\n  color: #FF4612;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
